// src/unAuth/LandingPage.js
import React, { useEffect } from "react";
import "./LandingPage.css";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import Timestamp from "./timestampcomp/Timestamp";
import HowItWorks from "./components/HowItWorks";
import CreatorTips from "./components/CreatorTips";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

const LandingPage = () => {
  useEffect(() => {
    const els = document.querySelectorAll('[data-animate="fade-up"]');
    if (els.length === 0) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in-view");
        });
      },
      { rootMargin: "0px 0px -50px 0px", threshold: 0.08 }
    );
    els.forEach((el) => obs.observe(el));
    return () => {
      obs.disconnect();
    };
  }, []);

  return (
    <div className="landing-page-container">
      <div className="landing-content-wrapper">
        <NavBar />
        <main id="main-content" className="main-contents">
          <Hero />
          <section
            id="generator"
            aria-labelledby="generator-title"
            data-animate="fade-up"
          >
            <Timestamp />
          </section>
          <div className="section-divider" aria-hidden="true" />
          <HowItWorks />
          <div className="section-divider" aria-hidden="true" />
          <CreatorTips />
          <div className="section-divider" aria-hidden="true" />
          <FAQ />
          <Footer />
        </main>
      </div>
    </div>
  );
};

export default LandingPage;
